import Http from './../../services/HTTP';

const GET_VENDOR_MESSAGES = "GET_VENDOR_MESSAGES";
function getVendorMessagesWaiting() {
    return {
      type: GET_VENDOR_MESSAGES,
      get_vendor_messages_waiting: true,
      get_vendor_messages_response: {},
      get_vendor_messages_error: {},
    };
  }

  function getVendorMessagesSuccess(response) {
    return {
      type: GET_VENDOR_MESSAGES,
      get_vendor_messages_waiting: false,
      get_vendor_messages_response: response,
      get_vendor_messages_error: {},
    };
  }
  
  function getVendorMessagesError(error) {
    return {
      type: GET_VENDOR_MESSAGES,
      get_vendor_messages_waiting: false,
      get_vendor_messages_response: {},
      get_vendor_messages_error: error,
    };
  }

  function getVendorMessagesEmpty() {
    return {
      type: GET_VENDOR_MESSAGES,
      get_vendor_messages_waiting: false,
      get_vendor_messages_response: {},
      get_vendor_messages_error: {},
    };
  }
  
  function getVendorMessages(data) {
    return (dispatch) => {
      dispatch(getVendorMessagesWaiting());
      const post = Http.GET("v1/medical_delivery/vendors/messages");
      post
        .then((response) => {
          if (response !== undefined) dispatch(getVendorMessagesSuccess(response));
        })
        .catch((error) => {
          dispatch(getVendorMessagesError(error));
        });
    };
  }

  export {
      GET_VENDOR_MESSAGES,
      getVendorMessages,
      getVendorMessagesEmpty
  }